export default ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="41"
    height="59"
    viewBox="0 0 41 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <path
        opacity="0.6"
        d="M20.4967 37.0181C17.546 37.0181 15.1537 39.4098 15.1537 42.3611C15.1537 45.3125 17.5454 47.7042 20.4967 47.7042C23.4481 47.7042 25.8398 45.3125 25.8398 42.3611C25.8398 39.4098 23.4475 37.0181 20.4967 37.0181ZM34.9261 27.051V14.9294C34.9261 6.97271 28.4528 0.5 20.4967 0.5C12.5407 0.5 6.06739 6.97271 6.06739 14.9294V27.051C2.77648 27.6437 0.269531 30.5227 0.269531 33.9822V51.4511C0.269531 55.3378 3.43172 58.5 7.31841 58.5H33.6751C37.5618 58.5 40.724 55.3378 40.724 51.4511V33.9822C40.724 30.5227 38.217 27.6437 34.9261 27.051ZM10.358 14.9294C10.358 9.33868 14.9061 4.79062 20.4967 4.79062C26.0874 4.79062 30.6355 9.33868 30.6355 14.9294V26.9333H10.358V14.9294ZM36.4333 51.4511C36.4333 52.9718 35.1958 54.2094 33.6751 54.2094H7.31841C5.79769 54.2094 4.56015 52.9718 4.56015 51.4511V33.9822C4.56015 32.4614 5.79769 31.2239 7.31841 31.2239H33.6751C35.1958 31.2239 36.4333 32.4614 36.4333 33.9822V51.4511Z"
        fill="#EFABB8"
      />
    </g>
  </svg>
);
